import dayjs from 'dayjs';

export const formatDate = (date: string, format: string = 'MMM D, YYYY') => dayjs(date).format(format);

export const formatNumber = (value: number, maximumFractionDigits: number = 2) =>
  new Intl.NumberFormat('en-GB', {
    maximumFractionDigits,
    minimumFractionDigits: 0
  }).format(value);
